import { Link } from "react-router-dom";
import Logo from "./Logo";
import ThemeToggle from "./ThemeToggle";

export default function PublicNav({ sticky = false, showEmployers = true }) {
  const navClass = sticky
    ? "flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-white/10 gap-2 sticky top-0 z-30 bg-white dark:bg-brand-dark-bg"
    : "flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-white/10 gap-2";

  return (
    <nav className={navClass}>
      <Logo className="h-12 w-auto flex-shrink-0" />
      <div className="flex gap-2 sm:gap-4 items-center text-sm">
        <ThemeToggle />
        <Link
          to="/login"
          className="hidden sm:inline-block text-gray-600 dark:text-gray-300 hover:text-brand-violet dark:hover:text-brand-violet-on-dark whitespace-nowrap"
        >
          Sign in
        </Link>
        <Link
          to="/register"
          className="bg-brand-violet text-white px-3 sm:px-4 py-1.5 rounded-md hover:opacity-90 transition whitespace-nowrap"
        >
          Get started
        </Link>
        {showEmployers && (
          <Link
            to="/employers/register"
            className="hidden sm:inline-block text-gray-400 dark:text-gray-500 hover:text-brand-violet dark:hover:text-brand-violet-on-dark text-xs self-center whitespace-nowrap"
          >
            Employers →
          </Link>
        )}
      </div>
    </nav>
  );
}
